import { Model } from "@vuex-orm/core";
import BizReviewType from "./BizReviewType";

export default class BizReviewHistory extends Model {
  static entity = "bizReviewHistories";

  static fields() {
    return {
      id: this.attr(),
      // accountId: this.attr(),
      // isDirty: this.boolean(false),
      bizReviewTypeId: this.number(),
      reviewCount: this.number(),
      reviewAvg: this.number(),
      // name: this.string(),
      // code: this.string()
      // googleReviewCount: this.number(),
      // googleReviewAvg: this.number(),
      // facebookReviewCount: this.number(),
      // facebookReviewAvg: this.number(),
      // yelpReviewCount: this.number(),
      // yelpReviewAvg: this.number(),
      createdAt: this.attr(),
      // bizReviewType: this.belongsTo(BizReviewType, "bizReviewTypeId")
    };
  }

  static mutators() {
    return {
      createdAt(value) {
        if (typeof value == "string") {
          value = Date.parse(value);
        }
        return value;
      }
    };
  }
}
